import { Fragment } from "react";
import Stack from "@vapor/react-material/Stack";
import Divider from "@vapor/react-material/Divider";
import Autocomplete from "@vapor/react-material/Autocomplete";
import TextField from "@vapor/react-material/TextField";
import { AdapterDateFns } from "@vapor/react-x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@vapor/react-x-date-pickers/LocalizationProvider";
import { DatePicker } from "@vapor/react-x-date-pickers/DatePicker";
import { it } from "date-fns/locale";
import { isDateValid } from "../../businessLogic/helpers/dateHelpers";
import {
  TIPO_ANAGRAFICA_LEGALE_RAPP_KEY,
  TIPO_ANAGRAFICA_PROCURATORE_KEY,
  TIPO_ANAGRAFICA_TITOLARE_EFFETTIVO_KEY,
} from "../../businessLogic/constants/baseTableKeys";

export const AnagraficaTipoSection = ({
  currentAnagrafica,
  currentAnagraficaFascicolo,
  baseTipoAnagList,
  baseTipoRappList,
  tipoAnag,
  enableTipoRappDesc,
  isCessato,
  isNotLastVersion,
  onChange,
  onCessDateChange,
}) => {
  const tipoAnagOptions = baseTipoAnagList.filter((x) => {
    if (tipoAnag === "titolare") {
      return x.key === TIPO_ANAGRAFICA_TITOLARE_EFFETTIVO_KEY;
    }

    return x.key === TIPO_ANAGRAFICA_LEGALE_RAPP_KEY || x.key === TIPO_ANAGRAFICA_PROCURATORE_KEY;
  });

  const selectedTipoAnag =
    tipoAnagOptions.find((item) => item.id === currentAnagraficaFascicolo.tipoAnagId) || null;

  return (
    <Fragment>
      <Stack direction="row" spacing={2}>
        <Autocomplete
          id="ddlTipoAnag"
          size="small"
          options={tipoAnagOptions}
          sx={{ width: "100%" }}
          fullWidth
          readOnly={tipoAnag === "titolare" || isCessato || isNotLastVersion}
          onChange={onChange}
          value={selectedTipoAnag}
          isOptionEqualToValue={(option, value) =>
            currentAnagraficaFascicolo.tipoAnagId === undefined
              ? option.id === value.id
              : option.id === currentAnagraficaFascicolo.tipoAnagId
          }
          getOptionLabel={(option) => option.value}
          renderInput={(params) => (
            <TextField {...params} required label="Tipologia Anagrafica" sx={{ lineHeight: 1 }} />
          )}
        />
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={it}>
          <DatePicker
            label="Data cessazione ruolo"
            closeOnSelect
            format="dd/MM/yyyy"
            mask="__/__/____"
            maxDate={new Date()}
            minDate={
              isDateValid(currentAnagrafica.identifiedOn)
                ? new Date(currentAnagrafica.identifiedOn)
                : null
            }
            value={
              isDateValid(currentAnagraficaFascicolo.dataFine)
                ? new Date(currentAnagraficaFascicolo.dataFine)
                : null
            }
            onChange={onCessDateChange}
            slotProps={{
              textField: {
                required: false,
                placeholder: "dd/MM/yyyy",
                size: "small",
                fullWidth: true,
              },
            }}
            readOnly={isNotLastVersion}
          />
        </LocalizationProvider>
      </Stack>

      {tipoAnag === "collegate" && (
        <Stack direction="row" spacing={2}>
          <Autocomplete
            id="ddlTipoRapp"
            size="small"
            options={baseTipoRappList}
            sx={{ width: "50%" }}
            fullWidth
            onChange={onChange}
            isOptionEqualToValue={(option, value) =>
              currentAnagraficaFascicolo.tipoRappId === undefined
                ? option.id === value.id
                : option.id === currentAnagraficaFascicolo.tipoRappId
            }
            getOptionLabel={(option) => option.name}
            defaultValue={
              currentAnagraficaFascicolo.tipoRappId !== undefined
                ? baseTipoRappList.filter(
                    (item) => item.id === currentAnagraficaFascicolo.tipoRappId
                  )[0]
                : null
            }
            renderInput={(params) => (
              <TextField {...params} label="Rapppresentato mediante" sx={{ lineHeight: 1 }} />
            )}
            readOnly={isCessato || isNotLastVersion}
          />
          <TextField
            id="txtTipoRappDesc"
            label="Descrizione tipo rappresentanza"
            size="small"
            sx={{ width: "50%" }}
            multiline
            rows={1}
            defaultValue={currentAnagraficaFascicolo.tipoRappDesc}
            onChange={onChange}
            inputProps={{ autocomplete: "nope", maxLength: 50 }}
            readOnly={isCessato || !enableTipoRappDesc || isNotLastVersion}
          />
        </Stack>
      )}
      <Divider variant="standard" sx={{ pt: 1 }} />
    </Fragment>
  );
};
